import { validators } from "utils";
import * as Yup from "yup";

export interface ICreatePremiumServiceInterestFormSchema {
  district: string;
  customer: {
    fullName: string;
    phoneNumber: string;
    digitalAddress: string;
  };
}

export const PREMIUM_SERVICE_INTEREST_STATUS_BADGE_OPTIONS = {
  Pending: "bg-amber-100 text-amber-800",
  AppointmentConfirmed: "bg-green-100 text-green-800",
  Cancelled: "bg-red-100 text-red-800",
};

export const CreatePremiumServiceInterestSchema = Yup.object({
  district: Yup.string(),
  customer: Yup.object({
    fullName: Yup.string().required("Full name is required"),
    phoneNumber: Yup.string()
      .matches(validators.PhoneNumberRegex, "Kindly enter a valid phone number")
      .required("Phone number is required"),
    digitalAddress: Yup.string()
      .matches(validators.GhanaPostRegex, "Kindly enter a valid GhanaPost Address")
      .required("Digital address is required"),
  }),
});

export const getCreatePremiumServiceInterestInitialValues = (
  districtId?: string,
): ICreatePremiumServiceInterestFormSchema => ({
  district: districtId || "",
  customer: {
    fullName: "",
    phoneNumber: "",
    digitalAddress: "",
  },
});
